import type { LucideIcon } from 'lucide-react';
import type { SVGProps } from 'react';
import { cn } from '@/shared/utils/cn';

export type IconSize = 16 | 20 | 24;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'ref' | 'children'> {
  /** Glifo de `lucide-react` (iconos de interfaz). Los de dominio usan `DomainIcon`. */
  icon: LucideIcon;
  size?: IconSize;
  /** Texto para lectores de pantalla. Sin él, el icono es decorativo (aria-hidden). */
  label?: string;
}

/** Envoltorio único de lucide: trazo 1,75 y tamaños 16/20/24 para toda la interfaz. */
export function Icon({ icon: Glyph, size = 20, label, className, ...rest }: IconProps) {
  return (
    <Glyph
      width={size}
      height={size}
      strokeWidth={1.75}
      className={cn('shrink-0', className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...rest}
    />
  );
}
